import { render, staticRenderFns } from "./DashboardPeriodFilter.vue?vue&type=template&id=e4fbf21a"
import script from "./DashboardPeriodFilter.vue?vue&type=script&lang=js"
export * from "./DashboardPeriodFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports